import {SubscriptionVariant} from '@/types/subscription';
import {ROUTES} from './routesConstants';

export const HIDE_MENU_SUBSCRIPTIONS: SubscriptionVariant[] = ['safe_collab'];

export const SUBSCRIPTION_HOME_ROUTES: Partial<{
  [K in SubscriptionVariant]: string;
}> = {safe_collab: ROUTES.VETTING_HUB};
